import { Navigate } from "react-router-dom";
import { useAuth } from "database/useAuth";
import { canAccessStockIssues } from "./allowlist";

// Route guard — renders children only when the signed-in user is on the
// pilot allowlist; otherwise redirects them to /private/projects. Direct
// URL access is blocked at this layer; the Firebase callables enforce
// the same allowlist server-side so a bypassed client still can't read
// data. Split out of allowlist.js so the helper stays as plain .js —
// Vite's prod build rejects JSX in .js files.
export default function StockIssuesRouteGuard({ children }) {
  const { user } = useAuth();
  if (!canAccessStockIssues(user)) {
    return <Navigate to="/private/projects" replace />;
  }
  return children;
}
